import { render, staticRenderFns } from "./BranchSelect.vue?vue&type=template&id=4843dffc"
import script from "./BranchSelect.vue?vue&type=script&lang=js"
export * from "./BranchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports